
import { AuthService } from "@/services";
import Vue from "vue";
import AppMonthSelect from "@/components/MonthSelect.vue";
import { PeppolService } from "@/services/peppol-service";

export default Vue.extend({
	data(){
		return {
			sending: false,
			month: new Date().getMonth(),
			year: new Date().getFullYear()
		};
	},
	computed: {
		hasAccess():boolean {
			if (!AuthService.user) {
				return false;
			}
			return AuthService.user.hasPermission("admin");
		}
	},
	methods: {
		async sendEUSR(){
			if (this.sending) return;
			this.sending = true;
			try{
				let result = await PeppolService.sendEUSR(this.month, this.year);
				this.$wf.dialog(result, "OK");
			}catch(err){

			}
			this.sending = false;
		},
		async sendTSR(){
			if (this.sending) return;
			this.sending = true;
			try{
				let result = await PeppolService.sendTSR(this.month, this.year);
				this.$wf.dialog(result, "OK");
			}catch(err){

			}
			this.sending = false;
		}
	},
	components: {
		AppMonthSelect
	}
});
